module.exports = __webpack_public_path__ + "img/uma.30e6901c.svg";